module.exports = __webpack_public_path__ + "files/b53724381663e370e167285917d521e9.png";